import { ActionProps } from "react-querybuilder";
import Button from "../../button/button";
import { styled } from '@mui/material';
import { Add } from "@mui/icons-material";

const StyledAddButton = styled(Button)(({ theme: { palette } }) => ({
  ":hover": {
    backgroundColor: palette.theme?.secondary[100],
  },
  "&.MuiButton-text": {
    ":hover": {
      color: palette.theme?.secondary[1000],
    },
  },
}));

const AddFilterButton = (props: ActionProps) => {
  const { handleOnClick, ...rest } = props;
  return (
    <StyledAddButton
      onClick={handleOnClick}
      {...rest}
      className="add-filter"
      variant="text"
      startIcon={<Add/>}
    >
    Add Filter
    </StyledAddButton>
  );
};

export { AddFilterButton };
export default AddFilterButton;
